import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IBookPage, IBooksPageData } from '@/interfaces/booksPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';
import { getCurrentYear, getCurrentMonth } from '@/helpers/helpers';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { getCurrentPageName } from '@/helpers/helpers';

export interface INew extends IWidgetsSideBar {
  newBooks: IBookPage;
}

const New: FC<INew> = ({ newBooks, todayWidget, popularBooksWidget }) => {
  const pagesCount = Math.ceil(newBooks?.total_count / BOOKS_FOR_PAGE);
  const currentYear = getCurrentYear();
  const currentMonth = getCurrentMonth();

  //Seo block
  const SEO_TITLE = `Новые книги за ${currentMonth} ${currentYear} :: Электронная библиотека : скачать новые книги, справочники, журналы, словари в электронном виде, новинки книжного рынка${getCurrentPageName(newBooks.page)}`;
  const SEO_DESCRIPTION = `Новые книги за ${currentMonth} ${currentYear} в электронном варианте :: Bookz.ru`;
  const SEO_CANONICAL = '/new_books';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()} breadcrumbs={<Breadcrumbs firstPageName="Новинки книг" />} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget}>
      <SectionTitle name={`Новые книги :: ${currentMonth.toLowerCase()} ${currentYear}`} />
      <div>{newBooks.data && newBooks.data.length ? newBooks.data.map((book: IBooksPageData) => <BookCardItem book={book} key={book.id} />) : <div>Книги не найдены</div>}</div>
      <Pagination pagesCount={pagesCount ?? 0} postName="new_books/page=" />
    </Layout>
  );
};

export default New;
